module.exports = __webpack_public_path__ + "img/About_3.30657a5e.svg";